/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_EmailInputs */

const en_signin_email = /** @type {(inputs: Signin_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work email`)
};

const id_signin_email = /** @type {(inputs: Signin_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email kerja`)
};

/**
* | output |
* | --- |
* | "Work email" |
*
* @param {Signin_EmailInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_email = /** @type {((inputs?: Signin_EmailInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_EmailInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_email(inputs)
	return en_signin_email(inputs)
});